import OverviewInfo from './OverviewInfo';

export default OverviewInfo;
